/* eslint-disable class-methods-use-this */
import { WDH_GROUPING_TYPE } from 'utils/__enums/Administration/Organization'
import OrganizationEntity, {
  OrganizationTableEntity,
  OrganizationWDHFull,
} from 'utils/__interfaces/Administrations/Organizations/OrganizationEntity'
import { extractOrganizationEnfantWithIdAndState } from 'utils/Administrations/Organizations/OrganizationTable-utils'
import OrganizationWDH from 'utils/__interfaces/Administrations/Organizations/OrganizationWDH'
import {
  ORGANIZATION_APPLICATION,
  ORGANIZATION_TYPE,
} from 'utils/__consts/Common/Global'

class OrganizationNormalizer {
  normalize(organizationList: OrganizationWDH[]): OrganizationEntity[] {
    return organizationList.map(
      ({
        idOrganisation,
        nomOrganisation,
        nbEtablissements,
        organisationsEnfant,
      }) => ({
        id: String(idOrganisation),
        name: nomOrganisation,
        nbInstitutions: nbEtablissements,
        nbOrganizationEnfant: organisationsEnfant.length,
        application: `${ORGANIZATION_APPLICATION}`,
        type: `${ORGANIZATION_TYPE}`,
      })
    )
  }

  normalizeForTable(
    organizationList: OrganizationWDHFull[]
  ): OrganizationTableEntity[] {
    return organizationList.map((item) => {
      return {
        id: String(item.idOrganisation),
        idFonctionnelOrganisation: item.idFonctionnelOrganisation,
        typeOrganisation: item.typeOrganisation,
        nbEtablissements: String(item.nbEtablissements),
        nbOrganisations: String(item.organisationsEnfant.length),
        name: item.nomOrganisation,
        familleOrganisation: item.familleOrganisation,
        dateModification: item.dateModification,
        dateCreation: item.dateCreation,
        contenu:
          item.typeOrganisation === WDH_GROUPING_TYPE.WHD_BY_ORGANIZATION
            ? String(item.organisationsEnfant.length)
            : String(item.nbEtablissements),
        statut: item.statut,
        organisationsEnfant:
          item.organisationsEnfant.length > 0
            ? extractOrganizationEnfantWithIdAndState(item.organisationsEnfant)
            : [],
      }
    })
  }
}

export default new OrganizationNormalizer()
